<script setup lang="ts">
defineProps<{
  error?: string
}>();
</script>

<template>
  <p
    class="text-error text-sm mt-2xs empty:invisible group-has-[input:focus]:invisible h-5"
    v-text="error"
  />
</template>
